declare var $: any;

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
// https://davidwalsh.name/javascript-debounce-function
function debounce(func, wait, immediate: boolean = false) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

let snackbarTimeout:any = 0;

function snackbar(text, timeout: number = 5000) {
    console.log("Snackbar: " + text);
    if (snackbarTimeout) {
        $("#snackbar").hide(400);
        clearTimeout(snackbarTimeout);
        snackbarTimeout = false;


        setTimeout(function () {
            snackbar(text, timeout);
        }, 401);
        return;
    }

    $("#snackbar").text(text);
    $("#snackbar").show(400);

    snackbarTimeout = setTimeout(function () {
        $("#snackbar").hide(400);
        snackbarTimeout = false;
    }, timeout)
}

export default {
    debounce,
    snackbar
}